
import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { X } from 'lucide-react';

const ImportTokenQR = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const TOKEN_ADDRESS = "0x6508AEB49733f5dAAD56621Bc2AC05193F26b53a";

    return (
        <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 10000
        }}>
            <div className="modal-content" style={{
                background: '#1a1a2e',
                padding: '30px',
                borderRadius: '20px',
                maxWidth: '350px',
                width: '90%',
                color: 'white',
                textAlign: 'center',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 4px 30px rgba(0,0,0,0.5)',
                position: 'relative'
            }}>
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute', top: '15px', right: '15px',
                        background: 'none', border: 'none', color: '#aaa', cursor: 'pointer'
                    }}
                >
                    <X size={24} />
                </button>

                <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#4caf50' }}>
                    Escanea para Movil
                </h3>

                <div style={{ background: 'white', padding: '15px', borderRadius: '10px', display: 'inline-block', marginBottom: '20px' }}>
                    <QRCodeSVG value={TOKEN_ADDRESS} size={200} />
                </div>

                <p style={{ fontSize: '0.9rem', color: '#ccc', marginBottom: '15px' }}>
                    Escanea esto con tu App de Billetera o Cámara para copiar la dirección del contrato:
                </p>

                <div style={{
                    background: 'rgba(255,255,255,0.05)',
                    padding: '10px',
                    borderRadius: '5px',
                    fontSize: '0.75rem',
                    fontFamily: 'monospace',
                    wordBreak: 'break-all',
                    marginBottom: '20px',
                    userSelect: 'all'
                }}>
                    {TOKEN_ADDRESS}
                </div>

                <button
                    onClick={onClose}
                    className="cta-button"
                    style={{ width: '100%', padding: '12px' }}
                >
                    Cerrar
                </button>
            </div>
        </div>
    );
};

export default ImportTokenQR;
